import { call, put } from 'redux-saga/effects';
import { AsyncActionCreatorBuilder } from 'typesafe-actions';

export function* callApi<TResponse extends unknown = any, TError extends Error = Error>(
  api,
  action: {
    asyncAction: AsyncActionCreatorBuilder<any, [string, [TResponse, any]], [string, [TError, any]]>;
    responseExtractor?: (res) => TResponse;
    errorBuilder?: (err) => any;
  },
  ...args: any[]
) {
  const { asyncAction, responseExtractor = undefined, errorBuilder = err => err } = action;
  try {
    const response = yield call(api, ...args);
    yield put(asyncAction.success(responseExtractor?.(response) , undefined));
  } catch (err) {
    yield put(asyncAction.failure(errorBuilder(err), undefined));
  }
}
